// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts+js+dts,import_extension=.mjs"
// @generated from file myadapter/api/myadapter.proto (package nautilus.myadapter.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateSessionReply, CreateSessionRequest } from "./myadapter_pb.mjs";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service nautilus.myadapter.v1.MyAdapter
 */
export const MyAdapter = {
  typeName: "nautilus.myadapter.v1.MyAdapter",
  methods: {
    /**
     * CreateSession creates a new game session
     * Requires game id
     * Returns token for connecting and playing game
     *
     * @generated from rpc nautilus.myadapter.v1.MyAdapter.CreateSession
     */
    createSession: {
      name: "CreateSession",
      I: CreateSessionRequest,
      O: CreateSessionReply,
      kind: MethodKind.Unary,
    },
  }
};

